import { $api } from '@/shared/api/axiosInstance';

export const login = async () => {
    const url = '/api/auth/login';

    const res = await $api.post(url);

    return res.request.responseURL;
};
